import * as React from 'react'
import { Button } from 'react-bootstrap'
import Collapse from 'react-bootstrap/Collapse'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
/*
  this class is the page "cgu" the susers can find here the generela condtion of use of our website.
  They can click on each label to read a text about this label
*/
require('./cgu.css')

function CollapseCgu() {
    const [opencookies, setOpen1] = React.useState(false);
    const [openlicence, setOpen2] = React.useState(false);
    const [openiframes, setOpen3] = React.useState(false);
    const [opencl, setOpen4] = React.useState(false);
    const [openror, setOpen5] = React.useState(false);
    const [openrlw, setOpen6] = React.useState(false);
    const [opendisclaimer, setOpen7] = React.useState(false);
  
    return (
      <div id="button-container">
        <Button 
          id="button-cookies"
          onClick={() => setOpen1(!opencookies)}
          data-bs-target="#cookies-txt"
          aria-controls="cookies-txt"
          aria-expanded={opencookies}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Cookies
        </Button>
        <Collapse in={opencookies}>
            <div id="cookies-txt">
                <h3>
                    Nous utilisons des cookies. En accédant à PrivaSee, vous avez accepté d'utiliser des cookies en accord avec
                    la politique de confidentialité de PrivaSee.
                    La plupart des sites Web interactifs utilisent des cookies pour nous permettre de récupérer les détails de l'utilisateur à chaque visite. Les cookies sont
                    utilisé par notre site Web pour activer la fonctionnalité de certaines zones afin de faciliter la tâche des personnes qui visitent
                    notre site Web. Certains de nos affiliés / partenaires publicitaires peuvent également utiliser des cookies.
                </h3>
            </div>
        </Collapse>
        <Button
          id="button-licence"
          onClick={() => setOpen2(!openlicence)}
          data-bs-target="#licence"
          aria-controls="licence"
          aria-expanded={openlicence}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Licence
        </Button>
        <Collapse in={openlicence}>
            <div id="licence">
                <div id="license-txt">
                    <h3>
                        Sauf indication contraire, PrivaSee et / ou ses concédants de licence détiennent les droits de propriété intellectuelle pour tous
                        matériel sur PrivaSee. Tous les droits de propriété intellectuelle sont réservés. Vous pouvez y accéder depuis PrivaSee
                        pour votre usage personnel soumis aux restrictions définies dans ces termes et conditions.
                        <br/>
                        <br/>
                        <strong>Il ne faut pas:</strong><br/><br/>
                        - Republier le matériel de PrivaSee<br/>
                        - Vendre, louer ou sous-licencier du matériel de PrivaSee<br/>
                        - Reproduire, dupliquer ou copier du matériel de PrivaSee<br/>
                        - Redistribuer le contenu de PrivaSee<br/>
                    </h3>
                </div>
                <br/>
                <br/>
                <div id="aggreement-txt">
                    <h3>
                    Le présent accord commencera à la date des présentes. Nos conditions générales ont été créées avec le
                    aide du "https://www.termsandconditionsgenerator.com", Générateur de conditions générales et le "https://www.generateprivacypolicy.com", Générateur de politique de confidentialité.
                    Certaines parties de ce site Web offrent aux utilisateurs la possibilité de publier et d'échanger des opinions et des informations sur
                    certaines zones du site Web. PrivaSee ne filtre pas, ne modifie pas, ne publie pas et ne révise pas les commentaires avant leur
                    présence sur le site. Les commentaires ne reflètent pas les points de vue et les opinions de PrivaSee, ses agents
                    et / ou affiliés. Les commentaires reflètent les points de vue et les opinions de la personne qui publie leurs points de vue et
                    des avis. Dans la mesure permise par les lois applicables, PrivaSee ne sera pas responsable des commentaires
                    ou pour toute responsabilité, dommages ou dépenses causés et / ou subis à la suite de toute utilisation de et / ou
                    publication et / ou apparition des Commentaires sur ce site Web.<br/>
                    PrivaSee se réserve le droit de surveiller tous les commentaires et de supprimer tous les commentaires qui peuvent être
                    considéré comme inapproprié, offensant ou entraîne une violation des présentes conditions générales.
                    Vous garantissez et déclarez que:<br/><br/>
                        <br/><br/>
                    - Vous avez le droit de publier les commentaires sur notre site Web et de disposer de toutes les licences nécessaires et
                    consent à le faire;<br/><br/>
                    - Les Commentaires n'enfreignent aucun droit de propriété intellectuelle, y compris sans limitation
                    droit d'auteur, brevet ou marque de commerce de tout tiers;<br/><br/>
                    - Les Commentaires ne contiennent aucun commentaire diffamatoire, calomnieux, offensant, indécent ou autre
                    matériel illégal qui est une atteinte à la vie privée<br/><br/>
                    - Les commentaires ne seront pas utilisés pour solliciter ou promouvoir des affaires ou sur mesure ou présenter des publicités
                    activités ou activité illégale.<br/><br/>
                    Par la présente, vous accordez à PrivaSee une licence non exclusive pour utiliser, reproduire, modifier et autoriser d'autres personnes à
                    utiliser, reproduire et modifier l'un de vos commentaires sous toutes formes, formats ou supports.
                    Hyperliens vers notre contenu<br/><br/>
                    Les organisations suivantes peuvent créer un lien vers notre site Web sans autorisation écrite préalablement:<br/><br/>
                    - Organismes gouvernementaux;<br/><br/>
                    - moteurs de recherche;<br/><br/>
                    - Organisations de presse;<br/><br/>
                    - Les distributeurs d'annuaires en ligne peuvent créer un lien vers notre site Web de la même manière qu'ils créent un lien hypertexte vers les sites Web d'autres entreprises cotées<br/><br/>
                    - Entreprises accréditées à l'échelle du système, à l'exception de la sollicitation d'organisations à but non lucratif, de centres commerciaux caritatifs et de groupes de collecte de fonds caritatifs qui ne peuvent pas être liés par un hyperlien vers notre site Web.<br/><br/>
                    Ces organisations peuvent créer un lien vers notre page d'accueil, vers des publications ou vers d'autres informations du site Web à condition que le lien: (a) ne soit en aucun cas trompeur; (b) n'implique pas à tort un parrainage, une approbation ou une approbation de la partie liante et de ses produits et / ou services; et (c) s'inscrit dans le contexte du site de la partie liante.
                    Nous pouvons considérer et approuver d'autres demandes de lien provenant des types d'organisations suivants:<br/><br/>
                    - des sources d'informations communément connues sur les consommateurs et / ou les entreprises;<br/><br/>
                    - les sites communautaires dot.com<br/><br/>
                    - les associations ou autres groupes représentant des organismes de bienfaisance<br/><br/>
                    - distributeurs d'annuaires en ligne<br/><br/>
                    - les portails Internet<br/><br/>
                    - cabinets comptables, juridiques et de conseil<br/><br/>
                    - les établissements d'enseignement et les associations professionnelles.<br/><br/>
                    Nous approuverons les demandes de lien de ces organisations si nous décidons que:<br/><br/>
                    (a) le lien ne nous ferait pas paraître défavorable à nous-mêmes ou à nos entreprises accréditées; <br/><br/>
                    (b) l'organisation n'a aucun dossier négatif avec nous;<br/><br/>
                    (c) le bénéfice pour nous de la visibilité du lien hypertexte compense l'absence de PrivaSee; <br/><br/>
                    (d) le lien se situe dans le contexte d'informations générales sur les ressources.<br/><br/>
                    Ces organisations peuvent créer un lien vers notre page d'accueil tant que le lien: <br/><br/>
                    (a) n'est en aucun cas trompeur;<br/><br/>
                    (b) n'implique pas à tort un parrainage, une approbation ou une approbation de la partie liante et de ses produits ou services; <br/><br/>
                    et (c) s'inscrit dans le contexte du site de la partie liante.<br/><br/>
                    Si vous êtes l'une des organisations énumérées au paragraphe 2 ci-dessus et que vous souhaitez créer un lien vers notre site Web, vous devez nous en informer en envoyant un e-mail à PrivaSee. Veuillez inclure votre nom, le nom de votre organisation, vos coordonnées ainsi que l'URL de votre site, une liste de toutes les URL à partir desquelles vous avez l'intention de créer un lien vers notre site Web et une liste des URL de notre site vers lesquelles vous souhaitez lien. Attendez 2 à 3 semaines pour une réponse.<br/><br/>
                    Les organisations approuvées peuvent créer un lien hypertexte vers notre site Web comme suit:<br/><br/>
                    - En utilisant notre dénomination sociale; ou<br/><br/>
                    - En utilisant le localisateur de ressources uniforme auquel il est lié; ou<br/><br/>
                    - En utilisant toute autre description de notre site Web lié à qui a du sens dans le contexte et le format du contenu sur le site de la partie liante.<br/><br/>
                    Aucune utilisation du logo de PrivaSee ou de toute autre illustration ne sera autorisée pour la liaison en l'absence d'un accord de licence de marque.<br/><br/>
                    </h3>
                </div>
            </div>
        </Collapse>
        <Button
          id="button-iFrames"
          onClick={() => setOpen3(!openiframes)}
          data-bs-target="#iFrames-txt"
          aria-controls="iFrames-txt"
          aria-expanded={openiframes}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          iFrames
        </Button>
        <Collapse in={openiframes}>
            <div id="iFrames-txt">
                <h3>
                    Sans autorisation préalable et autorisation écrite, vous ne pouvez pas créer de cadres autour de nos pages Web
                    qui modifient de quelque manière que ce soit la présentation visuelle ou l'apparence de notre site Web.
                </h3>
            </div>
        </Collapse>
        <Button
          id="button-cl"
          onClick={() => setOpen4(!opencl)}
          data-bs-target="#contentLia-txt"
          aria-controls="contentLia-txt"
          aria-expanded={opencl}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Responsabilité du contenu
        </Button>
        <Collapse in={opencl}>
            <div id="contentLia-txt">
                <h3>
                    Nous ne serons pas tenus responsables de tout contenu qui apparaît sur votre site Web. Vous acceptez de protéger
                    et défendez-nous contre toutes les réclamations qui augmentent sur votre site Web. Aucun lien ne doit apparaître sur aucun
                    Site Web qui peut être interprété comme diffamatoire, obscène ou criminel, ou qui enfreint, autrement
                    viole, ou préconise la violation ou toute autre violation des droits de tiers.
                </h3>
            </div>
        </Collapse>
        <Button
          id="button-ror"
          onClick={() => setOpen5(!openror)}
          data-bs-target="#rights-txt"
          aria-controls="rights-txt"
          aria-expanded={openror}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Données
        </Button>
        <Collapse in={openror}>
            <div id="rights-txt">
                <h3>
                    Nous nous réservons le droit de vous demander de supprimer tous les liens ou tout lien particulier vers notre site Web. Tu
                    approuver la suppression immédiate de tous les liens vers notre site Web sur demande. Nous nous réservons également le droit de
                    amen ces termes et conditions et sa politique de liaison à tout moment. En vous connectant en permanence à notre
                    Site Web, vous acceptez d'être lié et de suivre ces termes et conditions de liaison.
                </h3>
            </div>
        </Collapse>
        <Button
          id="button-rlw"
          onClick={() => setOpen6(!openrlw)}
          data-bs-target="#removallinks-txt"
          aria-controls="removallinks-txt"
          aria-expanded={openrlw}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Suppression des liens du site
        </Button>
        <Collapse in={openrlw}>
            <div id="removallinks-txt">
                <h3>
                    Si vous trouvez un lien sur notre site Web qui est offensant pour quelque raison que ce soit, vous êtes libre de contacter et
                    informez-nous à tout moment. Nous examinerons les demandes de suppression de liens, mais nous ne sommes pas obligés de le faire.
                    ou pour vous répondre directement.
                    <br/>
                    <br/>
                    Nous ne garantissons pas que les informations sur ce site Web sont correctes, nous ne garantissons pas leur
                    l'exhaustivité ou l'exactitude; nous ne promettons pas non plus de garantir que le site Web reste disponible ou que
                    le matériel sur le site Web est tenu à jour.
                </h3>
            </div>
        </Collapse>
        <Button
          id="button-disclaimer"
          onClick={() => setOpen7(!opendisclaimer)}
          data-bs-target="#disclaimer-txt"
          aria-controls="disclaimer-txt"
          aria-expanded={opendisclaimer}
          style={{background:'#17a2b8', borderColor:'#17a2b8'}}
        >
          Responsabilité
        </Button>
        <Collapse in={opendisclaimer}>
            <div id="disclaimer-txt">
                <h3>
                    Dans la mesure maximale permise par la loi applicable, nous excluons toutes les représentations, garanties et
                    les conditions relatives à notre site Web et à l'utilisation de ce site Web. Rien dans cette clause de non-responsabilité:  
                    <br/>
                    <br/>
                    - limiter ou exclure notre ou votre responsabilité en cas de décès ou de blessures corporelles;<br/><br/>
                    - limiter ou exclure notre ou votre responsabilité en cas de fraude ou de fausse déclaration frauduleuse;<br/><br/>
                    - limiter l'une de nos ou vos responsabilités d'une manière non autorisée par la loi applicable; ou<br/><br/>
                    - exclure l'une de nos ou vos responsabilités qui ne peuvent être exclues en vertu de la loi applicable.<br/><br/>
                </h3>
            </div>
        </Collapse>
      </div>
    );
  }

export default class Contact extends React.Component {
    

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											Nos Conditions Générales d'Utilisation
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div id="welcome-txt" className="container">
                        <h1>Bienvenue sur Privasee !</h1>
                        <br></br>
                        <br></br>
                    </div>
                    <div id="intro-txt">
                        <h4>Les présentes conditions générales décrivent les règles et réglementations relatives à l'utilisation du site Web de PrivaSee, situé à <strong>https://privasee.netlify.app/.</strong></h4>
                    </div>
                    <br/>
                    <div id="prev-txt">
                       <h4>
                            En accédant à ce site Web, nous supposons que vous acceptez ces termes et conditions. Ne continuez pas à utiliser
                            PrivaSee si vous n'acceptez pas tous les termes et conditions énoncés sur cette page.
                        </h4>
                    </div>
                    <br/>
                    <div id="termi-txt">
                        <h4>
                            La terminologie suivante s'applique aux présentes conditions générales, à la déclaration de confidentialité et à la clause de non-responsabilité
                            Avis et tous les accords: «Client», «Vous» et «Votre» fait référence à vous, la personne se connecte sur ce site Web
                            et conforme aux termes et conditions de la société. «L'entreprise», «nous-mêmes», «nous», «nos»
                            et «Nous», fait référence à notre société. «Partie», «Parties» ou «Nous» désigne à la fois le Client et nous-mêmes.
                            Toutes les conditions font référence à l'offre, à l'acceptation et à la considération du paiement nécessaire pour entreprendre la
                            processus de notre assistance au client de la manière la plus appropriée dans le but exprès de
                            répondre aux besoins du client en ce qui concerne la fourniture des services déclarés de la société, conformément
                            et soumis à la loi en vigueur aux Pays-Bas. Toute utilisation de la terminologie ci-dessus ou d'autres mots
                            au singulier, au pluriel, en majuscules et / ou il / elle ou ils, sont considérés comme interchangeables et
                            donc comme se référant à la même chose.
                        </h4>
                    </div>
                    <br/>
                    <br/>
                    <CollapseCgu/>
				</section>
				
				<Footer/>
				</div>
			</>
		);
	}

}